var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHnd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 8C4 7.72386 3.77614 7.5 3.5 7.5C3.22386 7.5 3 7.72386 3 8V16C3 16.2761 3.22386 16.5 3.5 16.5C3.77614 16.5 4 16.2761 4 16V8ZM9.5 15.5C10.1383 15.5 10.7353 15.3296 11.2496 15.0321C11.4887 14.8938 11.7945 14.9755 11.9328 15.2145C12.0711 15.4535 11.9894 15.7594 11.7504 15.8977C11.088 16.2809 10.3188 16.5 9.5 16.5C7.01472 16.5 5 14.4853 5 12C5 9.51472 7.01472 7.5 9.5 7.5C11.9853 7.5 14 9.51472 14 12C14 13.933 15.567 15.5 17.5 15.5C19.433 15.5 21 13.933 21 12C21 10.067 19.433 8.5 17.5 8.5C16.8617 8.5 16.2647 8.67043 15.7504 8.96793C15.5113 9.1062 15.2055 9.02452 15.0672 8.78549C14.9289 8.54646 15.0106 8.2406 15.2496 8.10233C15.912 7.71915 16.6812 7.5 17.5 7.5C19.9853 7.5 22 9.51472 22 12C22 14.4853 19.9853 16.5 17.5 16.5C15.0147 16.5 13 14.4853 13 12C13 10.067 11.433 8.5 9.5 8.5C7.567 8.5 6 10.067 6 12C6 13.933 7.567 15.5 9.5 15.5Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHnd);
export default __webpack_public_path__ + "static/media/hnd.5e94f2c95319a24b7a4beed6c3d5ddba.svg";
export { ForwardRef as ReactComponent };